export const IS_HIDDEN_FROM_PORTAL = 'is_hidden_from_portal';
export const DELAY_SENDING_WEBHOOK = 'delay_sending_webhook';
export const SHOW_I9_COMPLIANCE_CENTER_AGENT =
  'show_i9_compliance_center_agent';
